<div class="bloco" [formGroup]="form">
  <p class="sub-section-sub-title">
    Tributação pelo Simples Nacional (ICMSSN) - os campos exibidos seguem o CSOSN informado.
  </p>

  <div class="row g-3">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>CSOSN</mat-label>
        <mat-select formControlName="codigoCsosn" (selectionChange)="onCsosnSelecionado()">
          <mat-option [value]="null">Selecione</mat-option>
          @for (c of listaCsosnDaOperacao; track c.codigo) {
            <mat-option [value]="c.codigo">{{ c.codigo }} - {{ c.descricao }}</mat-option>
          }
        </mat-select>
        @if (listaCsosn.length === 0) {
          <mat-hint>Lista indisponível - verifique o aviso acima</mat-hint>
        }
      </mat-form-field>
    </div>

    @if (isComCsosn) {
      @if (csosnTexto) {
      <div class="col-12">
        <app-alert-card [type]="csosnTexto.alertaTipo" [title]="csosnTexto.alertaTitulo">
          {{ csosnTexto.alertaTexto }}
        </app-alert-card>
      </div>
      }
    } @else {
      <div class="col-12">
        <app-empty-state icon="percent" title="Selecione o CSOSN"
          subtitle="Os campos e os valores apurados aparecem conforme o código informado."></app-empty-state>
      </div>
    }

    @if (ativo('pCredSN')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Alíquota do crédito (pCredSN) (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualCredito" class="campo-numero">
          @if (form.get('percentualCredito')?.hasError('required') && form.get('percentualCredito')?.touched) {
            <mat-error>Alíquota do crédito do ICMS é obrigatória.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (algumAtivo(['pRedBC', 'pICMS'])) {
      @if (ativo('pRedBC')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Redução da base de cálculo (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualReducaoBaseCalculo" class="campo-numero">
          @if (form.get('percentualReducaoBaseCalculo')?.hasError('required') && form.get('percentualReducaoBaseCalculo')?.touched) {
            <mat-error>Preenchimento obrigatório.</mat-error>
          }
        </mat-form-field>
      </div>
      }
      @if (ativo('pICMS')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Alíquota ICMS (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquota" class="campo-numero">
          @if (form.get('percentualAliquota')?.hasError('required') && form.get('percentualAliquota')?.touched) {
            <mat-error>Preenchimento obrigatório.</mat-error>
          }
        </mat-form-field>
      </div>
      }
    }

    @if (algumAtivo(['modBCST', 'pMVAST', 'pRedBCST', 'pICMSST', 'pFCPST'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>swap_horiz</mat-icon>
            <span>Substituição tributária (ICMS-ST)</span>
          </div>
          <div class="row g-3">
            @if (ativo('modBCST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Modalidade da BC da ST</mat-label>
                <mat-select formControlName="codigoModalidadeBaseCalculoSt">
                  @for (m of listaModalidadeBcSt; track m.valor) {
                    <mat-option [value]="m.valor">{{ m.descricao }}</mat-option>
                  }
                </mat-select>
                @if (form.get('codigoModalidadeBaseCalculoSt')?.hasError('required') && form.get('codigoModalidadeBaseCalculoSt')?.touched) {
                  <mat-error>Modalidade da BC da ST é obrigatória.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pMVAST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>MVA ST (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualMvaSt" class="campo-numero">
                @if (form.get('percentualMvaSt')?.hasError('required') && form.get('percentualMvaSt')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pRedBCST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Redução da BC ST (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualReducaoBaseCalculoSt" class="campo-numero">
                @if (form.get('percentualReducaoBaseCalculoSt')?.hasError('required') && form.get('percentualReducaoBaseCalculoSt')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pICMSST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota ICMS-ST (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaSt" class="campo-numero">
                @if (form.get('percentualAliquotaSt')?.hasError('required') && form.get('percentualAliquotaSt')?.touched) {
                  <mat-error>Alíquota do ICMS-ST é obrigatória.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pFCPST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Base do FCP ST</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="valorMask" formControlName="valorBaseFcpSt" class="campo-numero">
              </mat-form-field>
            </div>
            }
            @if (ativo('pFCPST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>FCP ST (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualFcpSt" class="campo-numero">
                @if (form.get('percentualFcpSt')?.hasError('required') && form.get('percentualFcpSt')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </div>
    }

    @if (algumAtivo(['pST', 'pFCPSTRet'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>receipt</mat-icon>
            <span>ST cobrada anteriormente</span>
          </div>
          <div class="row g-3">
            @if (ativo('pST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota suportada pelo consumidor (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualSuporteStRetido" class="campo-numero">
                @if (form.get('percentualSuporteStRetido')?.hasError('required') && form.get('percentualSuporteStRetido')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pFCPSTRet')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>FCP ST retido (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualFcpStRetido" class="campo-numero">
                @if (form.get('percentualFcpStRetido')?.hasError('required') && form.get('percentualFcpStRetido')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </div>
    }

    @if (ativo('pICMSEfet')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Alíquota efetiva ICMS (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaEfetiva" class="campo-numero">
          @if (form.get('percentualAliquotaEfetiva')?.hasError('required') && form.get('percentualAliquotaEfetiva')?.touched) {
            <mat-error>Alíquota do ICMS efetivo é obrigatória.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (ativo('pCredSN') || algumAtivo(['modBCST', 'pMVAST', 'pRedBCST', 'pICMSST', 'pFCPST'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>calculate</mat-icon>
            <span>Valores apurados</span>
          </div>
          @if (isRecalculoPendente || !isComValoresApurados) {
            <app-empty-state icon="calculate" title="Nenhum valor apurado"></app-empty-state>
          } @else {
            <div class="row g-3">
              @if (ativo('pCredSN')) {
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Valor do crédito (vCredICMSSN)</mat-label>
                    <input matInput type="text" [value]="form.get('valorCredito')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
              }
              @if (algumAtivo(['modBCST', 'pMVAST', 'pRedBCST', 'pICMSST', 'pFCPST'])) {
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Base de cálculo ST</mat-label>
                    <input matInput type="text" [value]="form.get('valorBaseCalculoSt')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Valor ICMS-ST</mat-label>
                    <input matInput type="text" [value]="form.get('valorIcmsSt')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Valor FCP ST</mat-label>
                    <input matInput type="text" [value]="form.get('valorFcpSt')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
